<template>
  <el-dialog :visible="value" :title="$t('News.NewsHistory.Title')" class="history-dialog" @open="getHistoryList" @close="closeDialog">
    <el-table
      v-loading="isLoading"
      class="history-table"
      :data="tableData"
      :empty-text="$t('News.NewsHistory.NoData')"
    >
      <el-table-column type="index" width="50" /> <!-- 實測此寬度可容納三位數index不換行 -->
      <el-table-column prop="Behavior" :label="$t('News.NewsHistory.Behavior')" width="50" align="center" />
      <el-table-column prop="Editor" :label="$t('News.NewsHistory.Editor')" />
      <el-table-column prop="From" :label="$t('News.NewsHistory.From')" width="200" />
      <el-table-column prop="ModificationAt" :label="$t('News.NewsHistory.ModificationAt')" width="160" />
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="closeDialog">{{ $t('General.OK') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { formatDateTime } from '@/js/utils'
import { apiAnnouncement } from '@/api/Announcement'
export default {
  props: {
    value: { // 實作component v-model
      type: Boolean,
      required: true
    },
    announcementId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      internalVisible: this.value,
      tableData: [],
      isLoading: false
    }
  },
  methods: {
    closeDialog () {
      this.$emit('input', false)
    },
    async getHistoryList () {
      // 取得異動紀錄列表
      try {
        this.isLoading = true
        const res = await apiAnnouncement.getLogs(this.announcementId)
        this.tableData = res.data.Data.AnnouncementChangeLogs.map(item => {
          return {
            ...item,
            ModificationAt: formatDateTime(item.ModificationAt)
          }
        })
      } catch (error) {
        // 不特別處理失敗情境，createAxiosInstance 會自動處理
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.history-dialog {
  overflow: hidden;
  ::v-deep .el-table {
    @include basicTable();
    width: 100%;
  }

  .dialog-footer {
    display: flex;
    justify-content: center;
  }
}
</style>
